import { useEffect } from "react";
import {
  Routes,
  Route,
  useNavigationType,
  useLocation,
} from "react-router-dom";
import PlashScreen from "./pages/PlashScreen";
import SignIn1 from "./pages/SignIn1";
import LoginFail from "./pages/LoginFail";
import Home from "./pages/Home";
import History2 from "./pages/History2";
import LoginEmail from "./pages/LoginEmail";
import SettingWifi from "./pages/SettingWifi";
import LoginPass from "./pages/LoginPass";
import SettingWifiDone1 from "./pages/SettingWifiDone1";
import HistoryCalendar from "./pages/HistoryCalendar";
import Login from "./pages/Login";
import SettingWifiDone from "./pages/SettingWifiDone";
import SettingWifi1 from "./pages/SettingWifi1";
import Introduction from "./pages/Introduction";
import Payment1 from "./pages/Payment1";
import Term from "./pages/Term";
import Payment from "./pages/Payment";
import SignIn from "./pages/SignIn";
import EditProfile from "./pages/EditProfile";
import Term1 from "./pages/Term1";
import History1 from "./pages/History1";
import DayCalendar from "./pages/DayCalendar";

function App() {
  const action = useNavigationType();
  const location = useLocation();
  const pathname = location.pathname;

  useEffect(() => {
    if (action !== "POP") {
      window.scrollTo(0, 0);
    }
  }, [action, pathname]);

  useEffect(() => {
    let title = "";
    let metaDescription = "";

    switch (pathname) {
      case "/":
        title = "";
        metaDescription = "";
        break;
      case "/31-sign-in1":
        title = "";
        metaDescription = "";
        break;
      case "/24-login-fail":
        title = "";
        metaDescription = "";
        break;
      case "/41-home":
        title = "";
        metaDescription = "";
        break;
      case "/41-history-4":
        title = "";
        metaDescription = "";
        break;
      case "/22-login-email":
        title = "";
        metaDescription = "";
        break;
      case "/41-setting-wifi":
        title = "";
        metaDescription = "";
        break;
      case "/22-login-pass":
        title = "";
        metaDescription = "";
        break;
      case "/42-setting-wifi-done1":
        title = "";
        metaDescription = "";
        break;
      case "/41-history-calendar":
        title = "";
        metaDescription = "";
        break;
      case "/21-login":
        title = "";
        metaDescription = "";
        break;
      case "/42-setting-wifi-done":
        title = "";
        metaDescription = "";
        break;
      case "/41-setting-wifi1":
        title = "";
        metaDescription = "";
        break;
      case "/6-introduction":
        title = "";
        metaDescription = "";
        break;
      case "/51-payment1":
        title = "";
        metaDescription = "";
        break;
      case "/31-term-2":
        title = "";
        metaDescription = "";
        break;
      case "/51-payment":
        title = "";
        metaDescription = "";
        break;
      case "/31-sign-in":
        title = "";
        metaDescription = "";
        break;
      case "/42-edit-profile":
        title = "";
        metaDescription = "";
        break;
      case "/31-term-1":
        title = "";
        metaDescription = "";
        break;
      case "/41-history-5":
        title = "";
        metaDescription = "";
        break;
    }

    if (title) {
      document.title = title;
    }

    if (metaDescription) {
      const metaDescriptionTag = document.querySelector(
        'head > meta[name="description"]'
      );
      if (metaDescriptionTag) {
        metaDescriptionTag.content = metaDescription;
      }
    }
  }, [pathname]);

  return (
    <Routes>
      <Route path="/" element={<PlashScreen />} />
      <Route path="/31-sign-in1" element={<SignIn1 />} />
      <Route path="/24-login-fail" element={<LoginFail />} />
      <Route path="/41-home" element={<Home />} />
      <Route path="/22-login-email" element={<LoginEmail />} />
      <Route path="/41-setting-wifi" element={<SettingWifi />} />
      <Route path="/22-login-pass" element={<LoginPass />} />
      <Route path="/42-setting-wifi-done1" element={<SettingWifiDone1 />} />
      <Route path="/41-history-calendar" element={<HistoryCalendar />} />
      <Route path="/21-login" element={<Login />} />
      <Route path="/42-setting-wifi-done" element={<SettingWifiDone />} />
      <Route path="/41-setting-wifi1" element={<SettingWifi1 />} />
      <Route path="/6-introduction" element={<Introduction />} />
      <Route path="/51-payment1" element={<Payment1 />} />
      <Route path="/31-term-2" element={<Term />} />
      <Route path="/51-payment" element={<Payment />} />
      <Route path="/31-sign-in" element={<SignIn />} />
      <Route path="/42-edit-profile" element={<EditProfile />} />
      <Route path="/31-term-1" element={<Term1 />} />
      <Route path="/41-history-5" element={<History1 />} />
      <Route path="/41-history-4" element={<DayCalendar />} />
    </Routes>
  );
}
export default App;
